module.exports = __webpack_public_path__ + "static/media/fabianCV_en.60eacba7.pdf";